import React, { lazy } from 'react';
import { IRoute } from '@/types/common';
import Index from '@/pages/index/index';
import CatListPageComponent from '@/pages/cat-list/index';
import CommonShareComponent from '@/pages/common-share/index';
// import AntiAbuse from '@/pages/AntiAbuse/index';

// const Index = lazy(
//   () => import(/* webpackChunkName: 'index' */ '@/pages/index/index')
// );
const AddGroupChat = lazy(
  () => import(/* webpackChunkName: 'group' */ '@/pages/add-group-chat/index'),
);
const TopicDiscussPage = lazy(
  () =>
    import(/* webpackChunkName: 'topic' */ '@/pages/topic-discuss-page/index'),
);
const OpenUserLiving = lazy(
  () =>
    import(/* webpackChunkName: 'living' */ '@/pages/open-user-living/index'),
);
// const SpringFestivalActivities = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'spring' */ '@/pages/spring-festival-activities/index'
//     )
// );
const ShareMonthlyCard = lazy(
  () =>
    import(/* webpackChunkName: 'share' */ '@/pages/share-monthly-card/index'),
);
const ShareInfoCat = lazy(
  () =>
    import(
      /* webpackChunkName: 'shareInfoCat' */ '@/pages/share-info-cat/index'
    ),
);
const ShareVoteCat = lazy(
  () =>
    import(
      /* webpackChunkName: 'shareVoteCat' */ '@/pages/share-vote-cat/index'
    ),
);
const ShareBrandCooperation = lazy(
  () =>
    import(
      /* webpackChunkName: 'shareBrandCooperation' */ '@/pages/share-brand-cooperation/index'
    ),
);
const ShareVipMgm = lazy(
  () =>
    import(/* webpackChunkName: 'shareVipMgm' */ '@/pages/share-vip-mgm/index'),
);
const SpringShare = lazy(
  () =>
    import(/* webpackChunkName: 'springShare' */ '@/pages/spring-share/index'),
);
const SpringActivity = lazy(
  () =>
    import(
      /* webpackChunkName: 'springActivity' */ '@/pages/spring-activity/index'
    ),
);
// const HBridgeApiTest = lazy(
//   () =>
//     import(/* webpackChunkName: 'bridge' */ '@/pages/h5-bridge-api-test/index')
// );
const LiveHouseProductsConfig = lazy(
  () =>
    import(
      /* webpackChunkName: 'admin' */ '@/pages/live-house-products-config/index'
    ),
);
const BrandDetail = lazy(
  () => import(/* webpackChunkName: 'brand' */ '@/pages/brand-detail/index'),
);

const AnnualReport = lazy(
  () => import(/* webpackChunkName: 'brand' */ '@/pages/annual-report/index'),
);

// const CatListPageComponent = lazy(
//   () => import(/* webpackChunkName: 'catList' */ '@/pages/cat-list/index')
// );

const LovePetDown = lazy(
  () => import(/* webpackChunkName: 'brand' */ '@/pages/love-pet-down/index'),
);

const PostDetail = lazy(
  () => import(/* webpackChunkName: 'post' */ '@/pages/post-detail/index'),
);

const VideoPostDetail = lazy(
  () =>
    import(
      /* webpackChunkName: 'videopost' */ '@/pages/video-post-detail/index'
    ),
);

const AntiAbuse = lazy(
  () => import(/* webpackChunkName: 'antiAbuse' */ '@/pages/AntiAbuse/index'),
);

const CommonDeeplink = lazy(
  () => import(/* webpackChunkName: 'brand' */ '@/pages/common-deeplink/index'),
);

const routes: IRoute[] = [
  {
    path: '/',
    element: <Index />,
    title: '街猫',
  },
  {
    path: '/group.html',
    element: <AddGroupChat />,
    title: '群聊',
  },
  {
    path: '/topic.html',
    element: <TopicDiscussPage />,
    title: '话题',
  },
  {
    path: '/living.html',
    element: <OpenUserLiving />,
    title: '街猫直播',
  },
  // {
  //   path: '/springFestivalActivities.html',
  //   element: <SpringFestivalActivities />,
  //   title: '爱的年夜饭，与猫猫同享',
  // },
  {
    path: '/shareMonthlyCard.html',
    element: <ShareMonthlyCard />,
    title: '好礼相送',
  },
  {
    path: '/common-share.html',
    element: <CommonShareComponent />,
    title: '',
  },
  // {
  //   path: '/shareInfoCat.html',
  //   element: <ShareInfoCat />,
  //   title: '',
  // },
  // {
  //   path: '/shareVoteCat.html',
  //   element: <ShareVoteCat />,
  //   title: '中华田园猫绝起...',
  // },
  {
    path: '/brand-detail.html',
    element: <BrandDetail />,
    title: 'loading...',
  },
  {
    path: '/shareBrandCooperation.html',
    element: <ShareBrandCooperation />,
    title: '哈啰街猫',
  },
  {
    path: '/shareVipMgm.html',
    element: <ShareVipMgm />,
    title: '哈啰街猫',
  },
  {
    path: '/springShare.html',
    element: <SpringShare />,
    title: '注册账号，领取猫猫饭卡',
  },
  {
    path: '/springActivity.html',
    element: <SpringActivity />,
    title: '领取免费投喂饭卡',
  },
  // {
  //   path: '/hBridgeApiTest.html',
  //   element: <HBridgeApiTest />,
  //   title: 'h5-bridge-api-test',
  // },
  {
    path: '/liveHomeProductsConfig.html',
    element: <LiveHouseProductsConfig />,
    title: '直播间商品管理',
  },
  {
    path: '/cat-list.html',
    element: <CatListPageComponent />,
    title: '',
  },
  // {
  //   path: '/annualReport.html',
  //   element: <AnnualReport />,
  //   title: '',
  // },
  {
    path: '/lovePetDown.html',
    element: <LovePetDown />,
    title: '',
  },
  {
    path: '/antiAbuse.html',
    element: <AntiAbuse />,
    title: '...',
  },
  {
    path: '/post-detail.html',
    element: <PostDetail />,
    title: '...',
  },
  {
    path: '/video-post-detail.html',
    element: <VideoPostDetail />,
    title: '...',
  },
  {
    path: '/common-deeplink.html',
    element: <CommonDeeplink />,
    title: '...',
  },
];

export default routes;
